import { render } from "./productsCart.vue?vue&type=template&id=89298946"
import script from "./productsCart.vue?vue&type=script&lang=js"
export * from "./productsCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__